import { factory } from '../positions/asset-position-details/asset-position-details-container';

export default factory({
  rowFragmentExtend: {
    maturityDate: true,
    nextFixingDate: true,
  },
});
